import React from 'react'
import HTag from '@/lib/HTag'
import Img from '../Img'
import { graphql, useStaticQuery } from 'gatsby'

const AmbassadorList = ({ heading }) => {
	const { allSanityAmbassador } = useStaticQuery(query)

	// reorder by type
	const ambassadors = ['Next Step Up Ambassador', 'Teen Ambassador', 'Young Adult Ambassador']
		.flatMap(type => allSanityAmbassador.nodes.filter(a => a.type === type))

	return (
		<section className="bg-grounding-navy text-orange text-center">
			<div className="section">
				<HTag className="h1 mb-12" {...heading} />

				<dl className="carousel full-width gap-8 mt-8 px-4 pb-4">
					{ambassadors?.map(({ name, type, schoolOrWork, image }, key) => (
						<div className="richtext-sm" key={key}>
							<dt>
								<figure className="aspect-square rounded-full overflow-hidden">
									{!!image
										? <Img className="w-full" image={image} alt={name} />
										: <div className="w-full h-full bg-white/5" />
									}
								</figure>
								<h3 className="h3 mt-4 text-caribbean">{name}</h3>
							</dt>
							<dd className="richtext-sm">
								<p className="technical">{type}</p>
								<p className="text-lg font-bold">{schoolOrWork}</p>
							</dd>
						</div>
					))}
				</dl>
			</div>
		</section>
	)
}

export default AmbassadorList

const query = graphql`query AmbassadorList {
	allSanityAmbassador(sort: {fields: name, order: ASC}) {
		nodes {
			name
			type
			schoolOrWork
			image { asset { gatsbyImageData(placeholder: NONE, aspectRatio: 1) } }
		}
	}
}`
